import * as API from '@/api'
import request from './index'

/**
 * 用户信息
 */
export function info() {
    return request.get(API.LOGIN_INFO)
}

/**
 * 登录
 */
export function login(admin_name, verify_num) {
    return request.post(API.LOGIN, {
        admin_name,
        verify_num,
        login_client: 2
    })
}

/**
 * 密码登录
 * @param {*} data 
 */
export function passLogin(admin_name, password) {
    return request.post(API.PASS_LOGIN, {
        admin_name,
        password,
    })
}

//修改本身密码
export function editPass(data) {
    return request.post(API.EDIT_ADMIN_PASS, data)
}

// 发送手机验证码
export function sendSmsVerify(admin_name) {
    return request.get(API.SMS_VERIFY, {
        params: {
            admin_name
        }
    })
}

// 更换手机号发送手机验证码
export function sendChangeMobileSmsVerify() {
    return request.post(API.SMS_VERIFY_CHANGE_MOBILE)
}

// 更换手机号
export function changeMobile(data) {
    return request.post(API.CHANGE_MOBILE, data)
}
